import { Pipe, PipeTransform } from '@angular/core';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';

@Pipe({
  name: 'filterUnifiedDataList',
  pure: false,
})
export class FilterUnifiedDataList implements PipeTransform {
  transform(mergedData: any[], filterConfiguration: any[], filterText = ''): any {
    if (!mergedData.length) {
      return [];
    }

    const users = mergedData.filter((item) => item.dataType === 'users');
    const templates = mergedData.filter((item) => item.dataType === 'template');

    const userConfig = filterConfiguration.find((config) => config.key === 'users');
    const templateConfig = filterConfiguration.find((config) => config.key === 'template');

    const selectedUsers = userConfig?.selectedData || [];
    const selectedTemplates = templateConfig?.selectedData || [];

    let filteredUsers = users.filter((user) => selectedUsers.findIndex((x) => x.id === user.id || x.user_id === user.user_id) === -1);
    let filteredTemplates = templates.filter(
      (template) => selectedTemplates.findIndex((x) => x.vault_id === template.id || (x.id === template.id && x.user_id === template.user_id)) === -1
    );

    if (filterText?.length) {
      filteredUsers = filteredUsers
        .filter((x) => {
          if (x.user_type) {
            return x.user_type !== UserTypeEnum.Professional;
          }
          return true;
        })
        .filter((relationship) => {
          let relationshipName = '';
          if (relationship.user_first_middle_name && relationship.user_last_name) {
            relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
          } else if (relationship.name) {
            relationshipName = relationship.name;
          }
          const searchWords = filterText
            .toLowerCase()
            .split(' ')
            .filter((word) => word.length > 0);
          return searchWords.every((word) => relationshipName?.toLowerCase()?.includes(word));
        });

      let templateFilterItems = [];
      filteredTemplates.forEach((element) => {
        if (element?.name?.toLowerCase().includes(filterText.toLowerCase())) {
          templateFilterItems.push(element);
        } else if (element?.vault_name?.toLowerCase().includes(filterText.toLowerCase())) {
          templateFilterItems.push(element);
        } else if (element?.form_name?.toLowerCase().includes(filterText.toLowerCase())) {
          templateFilterItems.push(element);
        }
      });
      filteredTemplates = templateFilterItems;
    }

    return [...filteredUsers, ...filteredTemplates];
  }
}
